module.exports = __webpack_public_path__ + "static/media/onboarding-second.5dd6fb44.svg";